import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidatePropertyManagers } from './get-property-managers'

export const deletePropertyManager = async (id: number) => {
  await authAPI.delete(`/propertyManager/${id}`)
}

export const useDeletePropertyManager = () => {
  const invalidatePropertyManagers = useInvalidatePropertyManagers()

  return useMutation({
    mutationFn: deletePropertyManager,
    onSuccess: invalidatePropertyManagers,
  })
}
